import { render, staticRenderFns } from "./historiqueCotationCpElec.vue?vue&type=template&id=fa63c4da&scoped=true"
import script from "./historiqueCotationCpElec.vue?vue&type=script&lang=js"
export * from "./historiqueCotationCpElec.vue?vue&type=script&lang=js"
import style0 from "./historiqueCotationCpElec.vue?vue&type=style&index=0&id=fa63c4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa63c4da",
  null
  
)

export default component.exports